export default __webpack_public_path__ + "static/media/273.8429b7f5.png";